import axios from "axios";
import { logout } from "../Views/helpers/helper";
import KeycloakService from "../keycloak";
import { danger } from "../Views/helpers/message-box";
import store from "../redux/store";
import { getPageNotFoundRecode } from "../redux/pageNotFoundReducer";
import { getAccessToken } from "../Views/helpers/session";
import { getStoredEnterpriseId } from "../Views/helpers/enterprise-user.util";
import { retryWithRefreshedSession } from "./refreshSession";

let baseURL = process.env.REACT_APP_EDITOR_URL_GRAPEJS;

const exclude404ForApis = ["/default-templates", "/templates"];

const api = axios.create({
  baseURL,
  // Increase timeout to 10 minutes
  timeout: 600000,
});
// Add a request interceptor
api.interceptors.request.use(
  async (config) => {
    // Do something before request is sent
    config.headers["Authorization"] = `${getAccessToken()}`;
    const enterpriseId =
      localStorage.getItem("client_name") ||
      getStoredEnterpriseId() ||
      new URLSearchParams(window.location.search).get("enterprise_id");
    if (enterpriseId) {
      config.headers["enterprise-id"] = enterpriseId;
    }

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        const status = error.response ? error.response.status : null;
        if (status === 401) {
            // The access token lives an hour; refresh and retry instead of ending the session.
            // Sign out only when the refresh itself fails (revoked or expired refresh token).
            const retried = await retryWithRefreshedSession(api, error);
            if (retried) {
                return retried;
            }
            signOut();
        } else if (status === 404 &&
          !exclude404ForApis.some((api) => error?.response?.config?.url.includes(api))
        ) {
          store.dispatch(getPageNotFoundRecode(true));
        } else if (status === 500) {
          danger("Oops! Something went wrong. Please try again later.");
        }
        return Promise.reject(error);
    }
);

const signOut = async () => {
    await logout();
};

export default class EditorApiCalls {
  static post(url, payload) {
    return api.post(url, payload).then((response) => {
      return response;
    });
  }

  static patch(url, payload) {
    return api.patch(url, payload).then((response) => {
      return response;
    });
  }

  static put(url, payload) {
    return api.put(url, payload).then((response) => {
      return response;
    });
  }

  static get(url) {
    return api.get(url).then((response) => {
      return response;
    });
  }

  static delete(url) {
    return api.delete(url).then((response) => {
      return response;
    });
  }
}
